<template>
  <div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              :options='actions'
              @handleAction="handleAction"
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="getAllReglesAchatSelected().length > 0"
            ></selecteur-action>
          </div>
        </div>
      </div>
    </div>

    <v-client-table v-model="getReglesAchat" :columns="columns" :options="options"
                    class="disablePaddingInTd overflow-x-auto min-height-50vw">
      <template v-slot:child_row="props">
        <recapitulatif-commissions-garanties
          :commandesCommissions="
            getCommandesOfRegleAchat(props.row.produit.regroupementProduitId)">
        </recapitulatif-commissions-garanties>
      </template>
      <div slot="selected" slot-scope="props">
        <b-checkbox v-model="props.row.selected"
            @input="updateEtat(props.row, 'selected')"/>
      </div>
      <div slot="regroupementProduit" slot-scope="props">
        <router-link-blank
            :message="$t('addEditRegroupementProduit.information.code') +
              ' - ' + props.row.produit.regroupementProduit.code"
          :to="{
            name: 'c.bodac.catalogue-detailRegroupementProduit',
            params: {id: props.row.produit.regroupementProduitId}
          }">
        </router-link-blank>
      </div>
      <div slot="dateDebut" slot-scope="props">
        <span> {{ props.row.dateDebut | formatDate }} </span>
      </div>
      <div slot="dateFin" slot-scope="props">
        <span> {{ props.row.dateFin | formatDate }} </span>
      </div>
      <div slot="typeCalcul" slot-scope="props">
        <span> {{ $t(getTypeCalculLibelle(props.row.typeCalcul)) }} </span>
      </div>
      <template v-slot:societe="props">
        {{ getSocieteLibelle(props.row.produit.supportCommercial.societeId) }}
      </template>
      <div slot="generer" slot-scope="props" class="is-pulled-right">
        <b-tooltip
          v-if="getCommandesOfRegleAchat(props.row.produit.regroupementProduitId).length > 0"
          multiline class="width-40percent"
          :label="$t('listeCommandeCommissions.commandeGarantie.commissionGarantieDejaGeneree')"
          type="is-warning"
          position="is-left">
          <div
           class="button is-addOrEdit" @click="openPopUpPreventionGeneration(props.row.id)"
           :class="{
             'disabled':
                getCommandesOfRegleAchat(props.row.produit.regroupementProduitId).length > 0,
             'button-access-no-permission': !checkPermissions(permCommandes.maj)
            }">
            <span>
              {{ $t('listeCommandeCommissions.table.actions.genererCommissionGarantie') }}
            </span>
          </div>
        </b-tooltip>
        <div v-else
          class="button is-addOrEdit" @click="openPopUpPreventionGeneration(props.row.id)"
          :class="{
            'disabled':
              getCommandesOfRegleAchat(props.row.produit.regroupementProduitId).length > 0,
            'button-access-no-permission': !checkPermissions(permCommandes.maj)
          }">
          <span>
            {{ $t('listeCommandeCommissions.table.actions.genererCommissionGarantie') }}
          </span>
        </div>
      </div>
    </v-client-table>

    <b-modal v-model="popUpPreventionGeneration" has-modal-card class="modal">
      <pop-up-prevention :mess-header="$t('listeCommandeCommissions.actions.generation.title')"
                         mess-footer=""
                         :cancel="$t('general.button.cancel')"
                         :validate="$t('general.button.next')"
                         @no="popUpPreventionGeneration = false"
                         @yes="generationCommissionsGaranties()">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import { createNamespacedHelpers } from 'vuex';
import { generationCommissionsGarantiesAsync } from '@/api/presse/moisComptable/index';
import { COMMANDES } from '@/configuration/permissionsBodacConf';
import * as devisConf from '@/configuration/devisConf';
import * as produitConf from '@/configuration/catalogue/produitConf';
import {
  LISTE_TYPE_CALCUL_REGLE_ACHAT,
} from '@/configuration/presse/produitSalon/produitSalonConfiguration';
import recapitulatifCommissionsGaranties
  from '@/components/devisCommandes/detailDevisCommande/recapitulatifCommissionsGaranties';
import {
  TYPE_REFERENCE_EXTERNE_CA_GARANTI,
  TYPE_REFERENCE_EXTERNE_REVERSEMENT_GARANTI,
  ALL_TYPE_REFERENCE_EXTERNE_FOURNISSEUR,
  ALL_ETAT_COMMISSION,
  A_VERSER,
  ANNULEE,
  VERSEE,
} from '@/configuration/dcf/dcfConf';
import popUpPrevention from '@/components/general/popUpPrevention';
import messageErreur from '@/services/general/messageErreur';
import { SOUS_TYPE_AVOIR } from '@/configuration/facture/factureConf';
import { SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import selecteurAction from '@/components/general/selecteurAction';
import inProgress from '@/services/general/inProgress';
import { columnsSplice } from '@/services/general/columns';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { PGetAllForReglesAchatsAsync } from '@/api/commissionVendeur/index';
import {
  ACTION_GENERATION,
} from '@/configuration/commande/commandeConf';

const Societe = createNamespacedHelpers('societe');
const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'ListeCommissionsRegrpGaranties',
  components: {
    recapitulatifCommissionsGaranties,
    popUpPrevention,
    selecteurAction,
    routerLinkBlank,
  },
  props: {
    reglesAchatRegrpGarantiesInput: {
      type: Array,
      required: true,
    },
    commandesCommissionsRegrpGaranties: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      reglesAchatGaranties: [],
      commissionsGaranties: [],
      regleAchatIdSelected: null,
      commandeSelected: null,
      permCommandes: COMMANDES,
      sansSuite: devisConf.ETAT_SANSSUITE,
      clos: devisConf.ETAT_CLOTURER,
      enregistrer: devisConf.ETAT_ENREGISTRE,
      facturer: devisConf.ETAT_FACTURE,
      popUpPreventionAnnulation: false,
      popUpPreventionFacturation: false,
      popUpHistory: false,
      popUpPreventionGeneration: false,
      popUpPreventionEnregistrement: false,
      popUpChangeDates: false,
      caGaranti: TYPE_REFERENCE_EXTERNE_CA_GARANTI,
      mtReversGaranti: TYPE_REFERENCE_EXTERNE_REVERSEMENT_GARANTI,
      showFiltre: false,
      SOUS_TYPE_AVOIR,
      actions: [
        { action: ACTION_GENERATION, translation: 'listeCommandeCommissions.actionsMass.generation' },
      ],
      newDateForChange: new Date(),
      ALL_TYPE_REFERENCE_EXTERNE_FOURNISSEUR,
      A_VERSER,
      ANNULEE,
      VERSEE,
    };
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    getAllReglesAchatSelected() {
      return this.reglesAchatGaranties.filter((el) => { return el.selected; });
    },
    selectAll() {
      this.reglesAchatGaranties = this.reglesAchatGaranties
        .map(ra => { return { ...ra, selected: !this.allReglesAchatSelected }; });
    },
    updateEtat(row, key) {
      const find = this.getReglesAchat.find(el => el.id === row.id);
      if (find) this.$set(find, key, row[key]);
    },
    getLibelleAndRoutesForRegroupementProduct(produit) {
      const produitConfiguration = produitConf.CATEGORIE_PRODUIT.find((c) => {
        return c.code === produit.supportCommercial.categorieVente;
      });
      if (!produitConfiguration) return '';
      if (produitConfiguration.code !== produitConf.CATEGORIE_LOCATION) return produitConfiguration;
      return produit.numerique ? produitConfiguration.numerique : produitConfiguration.nonNumerique;
    },
    getSocieteLibelle(societeId) {
      return this.societesInformations.find(s => s.id === societeId)?.libelle ?? '';
    },
    getTypeCalculLibelle(code) {
      return LISTE_TYPE_CALCUL_REGLE_ACHAT.find((el) => el.key === code).libelle;
    },
    getEtatTraduction(value) {
      return ALL_ETAT_COMMISSION.find(e => e.value === value)?.libelle ?? '';
    },
    async handleAction(action) {
      switch (action) {
        case ACTION_GENERATION:
          await this.generationAllCommissionsGaranties();
          break;
        default:
          break;
      }
    },
    async generationCommissionsGaranties() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await generationCommissionsGarantiesAsync({ reglesAchatIds: [this.regleAchatIdSelected] });
        this.popUpPreventionGeneration = false;
        await this.recherche();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async generationAllCommissionsGaranties() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await generationCommissionsGarantiesAsync(
          { reglesAchatIds: this.getAllReglesAchatSelected().map(r => r.id) });
        this.popUpPreventionGeneration = false;
        await this.recherche();
        this.getAllReglesAchatSelected().forEach(ra => { ra.selected = false; });
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    openPopUpPreventionGeneration(regleAchatId) {
      this.popUpPreventionGeneration = true;
      this.regleAchatIdSelected = regleAchatId;
    },
    getCommandesOfRegleAchat(regroupementProduitId) {
      const reglesAchatRegrp = this.reglesAchatRegrpGarantiesInput.filter(regle => {
        return regle.produit.regroupementProduitId === regroupementProduitId;
      }).map(regle => regle.id);
      return this.getCommissionsGenerees.filter(
        c => reglesAchatRegrp.includes(c.referenceExterne5Id));
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    async recherche() {
      const commandesCommissions = await PGetAllForReglesAchatsAsync(
        this.reglesAchatRegrpGarantiesInput.map(r => r.id));
      this.commissionsGaranties = commandesCommissions.data.result;
      this.$emit('commissionRegrpGarantieGeneree', this.commissionsGaranties);
    },
  },
  computed: {
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    getCommissionsGenerees() {
      return this.commissionsGaranties;
    },
    getReglesAchat() {
      return this.reglesAchatGaranties;
    },
    allReglesAchatSelected() {
      return this.reglesAchatGaranties.every(p => p.selected);
    },
    multiSociete() {
      return this.societesInformations.length > 1;
    },
    columns() {
      const columns = ['selected', 'regroupementProduit', 'dateDebut', 'dateFin', 'typeCalcul', 'societe', 'generer'];
      if (!this.multiSociete) {
        columnsSplice(columns, 'societe');
      }
      return columns;
    },
    iconSelectTotal() {
      if (this.allReglesAchatSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          regroupementProduit: this.$i18n.t('listeCommandeCommissions.commandeGarantie.regroupementProduit'),
          dateDebut: this.$t('produitSalon.reglesAchat.dateDebut'),
          dateFin: this.$t('produitSalon.reglesAchat.dateFin'),
          typeCalcul: this.$t('produitSalon.reglesAchat.typeCalcul'),
          societe: this.$i18n.t('listeFactureCommissions.table.societe'),
          generer: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        sortable: ['dateDevisCommande', 'listeIntervenants', 'commissionEtat', 'remiseBancaireExterne', 'planMedia', 'commandeVenteExterne', 'factureVenteExterne', 'typeReferenceExterne', 'montantTtc'],
        columnsClasses: {
          listeIntervenants: 'ellipsis colonneListeIntervenants',
          generer: 'width-205px',
          selected: 'colonneSelected',
        },
      };
    },
  },
  mounted() {
    this.reglesAchatRegrpGarantiesInput = this.reglesAchatRegrpGarantiesInput.sort((a, b) => {
      return a.produit.reference.localeCompare(b.produit.reference);
    });
    this.reglesAchatRegrpGarantiesInput.forEach(regle => {
      const regleAchatExistante = this.reglesAchatGaranties.find(r => {
        return r.produit.regroupementProduitId === regle.produit.regroupementProduitId
        && r.dateDebut === regle.dateDebut && r.dateFin === regle.dateFin;
      });
      if (!regleAchatExistante) {
        this.reglesAchatGaranties.push(regle);
      }
    });

    this.commissionsGaranties = this.commandesCommissionsRegrpGaranties;
  },
};
</script>

<style scoped>

</style>
